import { render, staticRenderFns } from "./UsagePolicy.vue?vue&type=template&id=00e0b4a2&scoped=true&"
import script from "./UsagePolicy.vue?vue&type=script&lang=js&"
export * from "./UsagePolicy.vue?vue&type=script&lang=js&"
import style0 from "./UsagePolicy.vue?vue&type=style&index=0&id=00e0b4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e0b4a2",
  null
  
)

export default component.exports